/**
 * @file useAdminDashboard.js
 *
 * Hook for the admin dashboard — fetches enhanced stats including
 * trend data for charts, growth indicators, and recent activity.
 */
import { useState, useEffect } from "react";
import { adminService } from "../services/admin";

/**
 * @returns {{ stats: Object|null, isLoading: boolean, refresh: Function }}
 */
export function useAdminDashboard() {
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchStats = async () => {
    try {
      setIsLoading(true);
      const res = await adminService.getEnhancedStats();
      setStats(res.data);
    } catch {
      // Handled by interceptor
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchStats(); }, []);

  return { stats, isLoading, refresh: fetchStats };
}
